(() => {
  const cache = {};

  const isSet = (handle) => /discovery-set|gift-set|-set\b|sampler|samples/.test(handle || '');

  const sizedUrl = (url, width) => {
    if (!url) return url;
    return url.replace(/(\.[a-zA-Z]+)(\?|$)/, '_' + width + 'x$1$2');
  };

  const fetchSecondary = (handle) => {
    if (cache[handle] !== undefined) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js')
      .then((r) => r.json())
      .then((p) => {
        const secondary = p.images && p.images.length > 1 ? sizedUrl(p.images[1], 1000) : null;
        cache[handle] = secondary;
        return secondary;
      })
      .catch(() => {
        cache[handle] = null;
        return null;
      });
  };

  const applyToImg = (img, expected) => {
    if (!expected) return;
    img.dataset.ibExpected = expected;
    if (img.getAttribute('src') !== expected) img.setAttribute('src', expected);
  };

  const swapCard = (card) => {
    const handle = card.getAttribute('lb-product-handle');
    if (!handle || isSet(handle)) return;
    const img = card.querySelector('img');
    if (!img) return;
    if (cache[handle] !== undefined) {
      applyToImg(img, cache[handle]);
    } else {
      fetchSecondary(handle).then((secondary) => applyToImg(img, secondary));
    }
  };

  const swapAll = (root) => {
    (root || document).querySelectorAll('lb-upsell-flat-card').forEach(swapCard);
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      swapAll(document);
    });
  };

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.target.tagName === 'IMG') {
        const img = m.target;
        const expected = img.dataset.ibExpected;
        if (expected && img.getAttribute('src') !== expected) img.setAttribute('src', expected);
        continue;
      }
      if (m.addedNodes && m.addedNodes.length) schedule();
    }
  });

  const start = () => {
    swapAll(document);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
